<template>
  <div class="notice-detail-page">
    <div class="notice-detail-card">
      <h1 class="notice-title">{{ noticeDetail.title || "公告详情" }}</h1>
      <p class="notice-time">{{ noticeDetail.create_time || noticeDetail.created_at || "" }}</p>
      <div v-if="noticeContentHtml" class="notice-content" v-html="noticeContentHtml"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NoticeDetail",
  data() {
    return {
      noticeDetail: {},
      noticeContentHtml: "",
    };
  },
  watch: {
    "$route.query": {
      immediate: true,
      deep: true,
      handler(val) {
        if (val && val.id) {
          this.getNoticeDetail(val.id);
        }
      },
    },
  },
  methods: {
    extractDetail(source) {
      if (!source) return {};
      if (Array.isArray(source)) return source[0] || {};
      if (source.notice) return this.extractDetail(source.notice);
      if (source.detail && typeof source.detail === "object") {
        return this.extractDetail(source.detail);
      }
      if (source.data && typeof source.data === "object") {
        return this.extractDetail(source.data);
      }
      return source;
    },
    extractContent(detail) {
      if (!detail || typeof detail !== "object") return "";
      const commonKeys = [
        "content",
        "notice_content",
        "detail",
        "body",
        "desc",
        "description",
        "notice_desc",
        "introduce",
        "contents",
      ];
      for (const key of commonKeys) {
        if (typeof detail[key] === "string" && detail[key].trim()) {
          return detail[key];
        }
      }
      // 兜底：从对象里找最长文本字段作为正文
      let bestText = "";
      Object.keys(detail).forEach((key) => {
        const value = detail[key];
        if (typeof value === "string") {
          const text = value.trim();
          if (
            text &&
            key !== "title" &&
            key !== "create_time" &&
            key !== "created_at" &&
            text.length > bestText.length
          ) {
            bestText = text;
          }
        }
      });
      return bestText;
    },
    findContentDeep(source) {
      if (!source) return "";
      if (typeof source === "string") return source.trim();
      if (Array.isArray(source)) {
        for (const item of source) {
          const text = this.findContentDeep(item);
          if (text) return text;
        }
        return "";
      }
      if (typeof source === "object") {
        const keyPriority = [
          "content",
          "notice_content",
          "contents",
          "detail",
          "body",
          "desc",
          "description",
          "notice_desc",
          "introduce",
        ];
        for (const key of keyPriority) {
          if (typeof source[key] === "string" && source[key].trim()) {
            return source[key].trim();
          }
        }
        for (const key of Object.keys(source)) {
          const text = this.findContentDeep(source[key]);
          if (text && text !== source.title) return text;
        }
      }
      return "";
    },
    normalizeNoticeHtml(html = "") {
      if (!html) return "";
      return String(html)
        .replace(/<p[^>]*>\s*(&nbsp;|\u00a0|\s|<br\s*\/?>)*<\/p>/gi, "")
        .replace(/(<br\s*\/?>\s*){3,}/gi, "<br><br>")
        .trim();
    },
    getNoticeDetail(id) {
      this.$api
        .GET_NOTICE_DETAIL({ id })
        .then((resp) => {
          const detail = this.extractDetail(resp || {});
          this.noticeDetail = detail || {};
          const rawHtml = this.extractContent(detail) || this.findContentDeep(resp);
          this.noticeContentHtml = this.normalizeNoticeHtml(rawHtml);
        })
        .catch(() => {
          this.noticeDetail = {};
          this.noticeContentHtml = "";
        });
    },
  },
};
</script>

<style scoped lang="scss">
.notice-detail-page {
  min-height: calc(100vh - 50px);
  background: #fff;
  padding: 16px;
}

.notice-detail-card {
  max-width: 900PX !important;
  margin: 0 auto;
  text-align: left;
}

.notice-title {
  margin: 0;
  font-size: 19PX !important;
  line-height: 28PX !important;
  color: #333;
  word-break: break-word;
}

.notice-time {
  margin: 10PX 0 18PX !important;
  font-size: 12PX !important;
  color: #999;
}

.notice-content {
  font-size: 15PX !important;
  line-height: 24PX !important;
  color: #000;
  word-break: break-word;
  text-align: left;
}

.notice-empty {
  color: #999;
  font-size: 14px;
  margin: 10px 0 0;
}

::v-deep .notice-content p {
  margin: 0 0 8px;
}

@media (max-width: 991px) {
  .notice-detail-page {
    padding: 12px;
  }
  .notice-title {
    font-size: 17px;
    line-height: 25px;
  }
  .notice-time {
    margin: 8px 0 12px;
  }
  .notice-content {
    font-size: 14px;
    line-height: 22px;
  }
}

@media (min-width: 992px) {
  .notice-content {
    line-height: 1.8;
  }
  ::v-deep .notice-content p {
    margin: 0 0 4px !important;
    line-height: 1.8 !important;
  }
  ::v-deep .notice-content div,
  ::v-deep .notice-content span,
  ::v-deep .notice-content li,
  ::v-deep .notice-content strong,
  ::v-deep .notice-content b {
    line-height: 1.8 !important;
    white-space: normal !important;
  }
}
</style>
